import { ModuleConditionTypeEnum, IModuleConfigCondition } from "@/includes/logic/Modules/types";

export default abstract class ConfigCondition implements IModuleConfigCondition {
  abstract type: ModuleConditionTypeEnum

  async validate() {
    return true
  }
}
